import { useTranslation } from 'react-i18next';
import type { ItemTypeMap } from '@/common/api/types/itemType';
import { ItemTypeIcon } from '@/common/components/ui/item-type/itemTypeIcon';
import { OverflowTooltip } from '@/common/components/ui/OverflowTooltip';
import {
  useRegisterExtraItemId,
  useVisibleItem,
  useVisibleItems,
} from '../context/VisibleItemsContext';
import { CellTextSkeleton } from './withSkeleton';

export const ItemRefCell = ({
  value,
  itemTypesById,
}: {
  value?: number;
  itemTypesById?: ItemTypeMap;
}) => {
  const { t } = useTranslation();
  useRegisterExtraItemId(value);
  const item = useVisibleItem(value);
  const { restrictedIds } = useVisibleItems();

  if (value === undefined) return null;

  if (!item && !restrictedIds.has(value)) {
    return <CellTextSkeleton />;
  }

  if (!item) {
    return <OverflowTooltip>{t(($) => $.views.table.items.restrictedItemName)}</OverflowTooltip>;
  }

  const itemType =
    item.itemTypeId !== undefined && item.itemTypeId !== null
      ? itemTypesById?.[item.itemTypeId]
      : undefined;

  return (
    <span className="flex items-center gap-1 min-w-0">
      {itemType && <ItemTypeIcon itemType={itemType} aria-hidden />}
      <OverflowTooltip>{item.name}</OverflowTooltip>
    </span>
  );
};
